import { useParams } from 'react-router-dom';

export function parseParams() {
  const { id } = useParams();

  if (id) {
    const splitParam = id?.split('-');

    return {
      id: Number(splitParam?.[splitParam?.length - 1]),
      name: splitParam?.slice(0, splitParam?.length - 1)?.join('')
    };
  }

  return {
    id: undefined,
    name: undefined
  };
}
